export class SapAgentHeartbeatInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "agentStatus",
            "baseName": "agentStatus",
            "type": "SapAgentStatus",
            "format": ""
        },
        {
            "name": "agentVersion",
            "baseName": "agentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "contractVersion",
            "baseName": "contractVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "compatibilityStatus",
            "baseName": "compatibilityStatus",
            "type": "SapCompatibilityStatus",
            "format": ""
        },
        {
            "name": "cdcLagSeconds",
            "baseName": "cdcLagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "cursors",
            "baseName": "cursors",
            "type": "Array<SapAgentCursor>",
            "format": ""
        },
        {
            "name": "upgrade",
            "baseName": "upgrade",
            "type": "SapAgentUpgrade",
            "format": ""
        },
        {
            "name": "ackedCommands",
            "baseName": "ackedCommands",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return SapAgentHeartbeatInput.attributeTypeMap;
    }
    constructor() {
    }
}
